import get from 'lodash.get';
import platformAccess from '../constants/platform-access';

const getPlatformAccess = (rootState) =>
  get(rootState, 'user.userPreferences.platformAccess', platformAccess.LATITUDE);

export default getPlatformAccess;
